/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
import React from 'react';
import UploadIcon from '../../assets/emptyState/empty-state-upload-file.svg';
import styles from './fileViewer.module.less';

interface FileUploaderProps {
  disableAddition: boolean;
  fileRef: React.RefObject<HTMLInputElement>;
  fileUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputId?: string;
}

const FileUploader = ({
  disableAddition,
  fileRef,
  fileUpload,
  inputId = 'file-upload',
}: FileUploaderProps): JSX.Element =>
  !disableAddition && (
    <label htmlFor={inputId} className={styles.fileInput}>
      <img src={UploadIcon} alt="upload" />
      <input
        id={inputId}
        ref={fileRef}
        type="file"
        accept=".jpg, .jpeg, .png, .pdf"
        onChange={fileUpload}
        multiple
      />
    </label>
  );

export default FileUploader;
